export default ({ $axios, isDev }, inject) => {
    // We only want to inject this option if we are in dev mode
    if (!isDev) return

    const refreshConfig = async () => {
        const { data } = await $axios.post('/refresh-config/')
        console.log(data)
    }

    inject('devtools', {
        refreshConfig,
    })
}
